import React from 'react';
import { PenSquare, MessageCircle, Handshake } from 'lucide-react';
const steps = [{
  icon: PenSquare,
  title: 'Post Your Ad',
  description: 'Create your free ad in minutes. Add photos, description, and contact details.',
  step: '01'
}, {
  icon: MessageCircle,
  title: 'Connect Locally',
  description: 'Receive responses from interested buyers and sellers in Singapore.',
  step: '02'
}, {
  icon: Handshake,
  title: 'Close the Deal',
  description: 'Meet up, negotiate, and complete your transaction safely.',
  step: '03'
}];
export function HowItWorks() {
  return <section className="py-16 bg-white border-t border-gray-100" data-id="element-139">
      <div className="container mx-auto px-4" data-id="element-140">
        <div className="text-center mb-12" data-id="element-141">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-142">
            How Locanto Works
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-143">
            Join thousands of people in Singapore who buy, sell, and find
            opportunities every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-144">
          {/* Connector Line (Desktop only) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gray-100 -z-10" data-id="element-145"></div>

          {steps.map((item, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-146">
              <div className="relative mb-6" data-id="element-147">
                <div className="h-24 w-24 bg-[#E0F2F1] rounded-full flex items-center justify-center text-[#00897B]" data-id="element-148">
                  <item.icon className="h-10 w-10" data-id="element-149" />
                </div>
                <div className="absolute -top-2 -right-2 bg-[#00897B] text-white text-xs font-bold h-8 w-8 rounded-full flex items-center justify-center border-4 border-white" data-id="element-150">
                  {item.step}
                </div>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-151">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed max-w-xs" data-id="element-152">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}